var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ViewContainer',{staticClass:"view-main",class:{ 'is-gray': _vm.theme === 'gray' }},[_c('ViewWrapper',[_c('div',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"main-wrapper"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }